import React, {Component} from "react"
import {connect} from "react-redux"
import {change, formValueSelector, getFormValues, reduxForm} from "redux-form"
import {SubmitButton} from "./FormElements";
import SVG from 'react-inlinesvg';
import tickSvg from "../images/Tick.svg";
import brochure from "../images/brochure.svg";
import features from "../images/features.svg";
import offers from "../images/offers.svg";
import testdrive from "../images/testdrive.svg"
import { transformVehicle } from "../util/Validators";

const REACT_APP_XSITE_ORIGIN = process.env.REACT_APP_XSITE_ORIGIN;

const FORM_NAME = "fca-form";

class Form extends Component {

    constructor(props) {
        super(props);
        this.formName = "fca-form"
    }

    handleCrossSiteEvent = (event) => {
        if (new RegExp(REACT_APP_XSITE_ORIGIN).test(event.origin) && event.data.type === "widget-data") {
            event.data.data.forEach(item => {
                const res = item.split("=");
                const name = res[0];
                const val = res[1];
                if (name !== undefined && val !== undefined) {
                    let fieldName = name;
                    let fieldValue = val;
                    if (name === "gclsrc") {
                        fieldName = "utm_source";
                        fieldValue = "Google";
                    }
                    this.props.dispatch(change(this.formName, fieldName, decodeURIComponent(fieldValue).replace(  /-/g , " ")));
                    this.props.dispatch(change(this.formName, 'formState.selectModel', fieldValue.trim().length > 0));
                    if (this.props.handlePrePopulateModel) {
                        this.props.handlePrePopulateModel();
                    }
                }

            });
        }
        else if (new RegExp(REACT_APP_XSITE_ORIGIN).test(event.origin) && event.data.type === "digitalData"){
            this.props.dispatch(change(this.formName, 'digitalData' , event.data.data));
        }else if (new RegExp(REACT_APP_XSITE_ORIGIN).test(event.origin) && event.data.type === "eVar39"){
            this.props.dispatch(change(this.formName, 'eVar39' , event.data.data));
        }else if (new RegExp(REACT_APP_XSITE_ORIGIN).test(event.origin) && event.data.type === "GACLIENTID"){
            this.props.dispatch(change(this.formName, 'GACLIENTID' , event.data.data));
        }
    };

    componentWillMount = () => {
        window.addEventListener('message', this.handleCrossSiteEvent, false);
    };

    componentDidMount() {
        this.props.onInitCallback(this.props);
    }

    isFormValid = () => {
        return false;
    };

    render() {
        const { pristine, reset, submitting , asyncValidating , id , handleSubmit , upstreamerror, upstreamerrormessage} = this.props;
        const disabled = !this.isFormValid() ||  asyncValidating || submitting;
        const className = this.props.completed ? " completed " : "" ;
        return (
            <form id={id || ""} className={className} onSubmit={handleSubmit}>
                {this.props.children}
                <div className="row">
                    <div className="form-submit col-10 offset-1 col-sm-12 col-md-6 col-lg-6 offset-md-3 offset-lg-3">
                        {!submitting && !upstreamerror && <SubmitButton {...this.props} disabled={disabled}/>}
                        {submitting && <div className={'d-flex justify-content-center'}><SVG src={this.props.loader} /></div> }
                        {upstreamerror && upstreamerrormessage && 
                            <div className="d-flex justify-content-center"><i className="fas fa-ban"></i> {JSON.stringify(upstreamerrormessage).toString()}</div>
                        }
                        {upstreamerror && !upstreamerrormessage &&
                            <div className="d-flex justify-content-center"><p>Technical issue occurred ...</p><i className="fas fa-ban"></i></div>
                        }
                    </div>
                </div>
            </form>
        )
    }
}

class BaseForm extends Form {
}

BaseForm = reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: true
})(BaseForm);
BaseForm = connect(state => {
    return {

    };
})(BaseForm);

export default BaseForm;

export function NamedForm(name, p , validform = (v) => {  return false }) {

    class NamedForm extends Form {
        constructor(props) {
            super(props);
            this.formName = name;
        }

        componentDidMount() {
            p.componentWillMountCallback(this.props)
                .then((res) => {
                    for (let k of Object.keys(res)) {
                        const field = [k];
                        this.props.dispatch(change(name, field, res[k]));
                    }
                });
        }

        isFormValid = () => {
            return this.props.isFormValid ?  this.props.isFormValid(this.props) : false ;
        };

    }

    return connect(state => {

        const selector = formValueSelector(name);

        return {
            completed : selector(state, 'completed'),
            formValues : getFormValues(name)(state),
            upstreamerror : selector(state, 'upstreamerror'),
            upstreamerrormessage : selector(state, 'upstreamerrormessage'),
        };
    })(reduxForm(Object.assign({}, {form: name, destroyOnUnmount: true}, p.optionalConfig))(NamedForm));
}

export function RYIForm(props) {
    let Component = NamedForm(props.formName || "fca-ryi", props);

    return <Component {...props}/>
}

export function RYIRFCForm(props) {
    let Component = NamedForm(props.formName || "fca-ryi-rfc", props);

    return <Component {...props}/>
}

export function WFFHForm(props) {
    let Component = NamedForm(props.formName || "fca-wffh", props);

    return <Component {...props}/>
}



export function ContactUsForm(props){
    let Component = NamedForm(props.formName || "fca-cu", props);

    return <Component {...props}/>
}

export function RATDForm(props){
    let Component = NamedForm(props.formName || "fca-ratd" , props);

    return <Component {...props}/>
}

export function RAVDForm(props){
    let Component = NamedForm(props.formName || "fca-ravd" , props);

    return <Component {...props}/>
}

export function RABForm(props){
    let Component = NamedForm(props.formName || "fca-rab" , props);

    return <Component {...props}/>
}

export function RAQForm(props){
    let Component = NamedForm(props.formName || "fca-raq" , props , (v) => {
        return false;
    });

    return <Component {...props} />
}

class RYICompletedForm extends Component {
    render(){
        if(this.props.completed && this.props.result){
            return (<div id={'thank-you'} className={"form-completed"}>
                <div className={"d-flex justify-content-center"}><SVG className={""} src={tickSvg}/></div>
                <div className={"card text-center border-0"}>
                    <div className="card-body">
                        <div className="card-title justify-content-center">
                            <h2 className={""}>Thank you,&nbsp;{this.props.result && this.props.result["request"]["FirstName"]}</h2>
                        </div>
                        <div className="card-text justify-content-center">
                            <p className={" "}>{this.props.thankyoumessage}</p>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>)
        }
        else{
            return <span/>
        }
    }

}

class RYIRFCCompletedForm extends Component {
    render(){
        if(this.props.completed && this.props.result){
            return (<div id={'thank-you'} className={"form-completed"}>
                <div className={"d-flex justify-content-center"}><SVG className={""} src={tickSvg}/></div>
                <div className={"card text-center border-0"}>
                    <div className="card-body">
                        <div className="card-title justify-content-center">
                            <h2 className={""}>Thank you,&nbsp;{this.props.result && this.props.result["request"]["FirstName"]}</h2>
                        </div>
                        <div className="card-text justify-content-center">
                            <p className={" "}>{this.props.thankyoumessage}</p>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>)
        }
        else{
            return <span/>
        }
    }

}

class CompletedForm extends Component {
    render(){
        const isPreviewMode = false;
        
        const brandConfig = isPreviewMode ? {} : this.props.brandConfig;
        const values = isPreviewMode ? { vehicle: 'C10' } : this.props.values;
        const completed = isPreviewMode ? true : this.props.completed;
        const result = isPreviewMode ? {
            request: { FirstName: 'Martin' },
            response: { upstream: { request: { body: 'preview' } } }
        } : this.props.result;

        const LookupModelAsset = (name) => {
            return brandConfig !== undefined && brandConfig[name] ? `${brandConfig[name].url}` : ``;
        };

        if(completed && result){
            return (
                <div id={'thank-you'} className={'form-completed'}>
                    <div className="row mb-5">
                        <div className="col-sm-12 col-md-4 col-lg-4 offset-md-4 offset-lg-4">
                            <div className={""}>
                                <div className={"card border-0"}>
                                    <div className="card-body text-center">
                                        <picture>
                                            <img className={'border-0 img-fluid model-image'} src={LookupModelAsset(transformVehicle(values.vehicle))} alt={`${transformVehicle(values.vehicle)}`} />
                                        </picture>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div>
                                <div className={"card border-0 text-center"}>
                                    <div className="card-body">
                                        <div className="card-title justify-content-center">
                                            <h2 className={""}>Thank you,&nbsp;{result && result["request"]["FirstName"]}</h2>
                                        </div>
                                        <div className="card-text justify-content-center">
                                            <p className={" "}>{this.props.thankyoumessage}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.children}
                </div>
            )
        }
        else{
            return <span/>
        }
    }
}

function RATDOptions(props) {
    function Component(p){

        const brandConfig = p.brandConfig || {};
        const vehicle = p.vehicle || 'C10 Reev';
        const brand = p.brand || { name: 'leap' };

        return (
            <div>
                <div className={'row waiting p-3 pb-5 ml-3 mr-3 mt-5 card-deck'}>
                    <div className="col-sm-12 col-12">
                        <div className={"text-center m-4"}>
                            <h4>While you're waiting</h4>
                        </div>
                    </div>
                    <div className="col-lg-6"> {/* Changed from col-lg-4 to col-lg-6 */}
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={features} className={'finished-svg'}/> </div>

                                <div className="card-title text-center">
                                    <h5>Request a Quote</h5>
                                    <p>See great pricing at your local dealership.</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig, transformVehicle(vehicle), 'quote')}`} className={'btn btn-secondary mt-3'}>Request now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6"> {/* Changed from col-lg-4 to col-lg-6 */}
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={offers} className={"finished-svg"}/></div>

                                <div className="card-title text-center">
                                    <h5>Explore offers</h5>
                                    <p>Find a great deal on new {brand.name} models</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig, transformVehicle(vehicle), 'offers')}`} className={'btn btn-secondary mt-3'}>View offers</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-4">
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={brochure} className={'finished-svg'} /></div>

                                <div className="card-title text-center">
                                    <h5>Download Brochure</h5>
                                    <p>Find out more about your chosen {brand.name} model</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig, transformVehicle(vehicle), 'brochure')}`} className={'btn btn-secondary mt-3'}>Download</a>
                                </div>
                            </div>
                        </div>
                    </div> */}

                </div>
                <LeapReviews vehicle={vehicle} />
            </div>
        )
    }

    let C = connect((state) => {
        const selector = formValueSelector(props.formName);

        return {

            brandConfig: selector(state, 'brandConfig'),
            vehicle: transformVehicle(selector(state, 'vehicle')),
            brand: selector(state, 'brand')


        }
    })(Component);

    return <C {...props} />
}

export function RATDFinish(props){


    let Component = connect(state => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "We will contact you shortly to confirm your test drive." ,
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(CompletedForm);

    return <Component {...props}><RATDOptions {...props}/></Component>

}

export function RAVDFinish(props){


    let Component = connect(state => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "We will contact you shortly." ,
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(CompletedForm);

    return <Component {...props}><RATDOptions {...props}/></Component>

}

function RAQOptions(props) {

    function Component(p){

        const brandConfig = p.brandConfig || {};
        const vehicle = p.vehicle || 'C10';
        const brand = p.brand || { name: 'leap' };

        return (
            <div>
                <div className={'row waiting p-3 pb-5 ml-3 mr-3 mt-5 card-deck'}>
                    <div className="col-sm-12 col-12">
                        <div className={"text-center m-4"}>
                            <h4>While you're waiting</h4>
                        </div>
                    </div>
                    <div className="col-lg-6"> {/* Changed from col-lg-4 to col-lg-6 */}
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={testdrive} className={'finished-svg'} /></div>

                                <div className="card-title text-center">
                                    <h5>Book a Test Drive</h5>
                                    <p>Get behind the wheel at your local dealership.</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig , transformVehicle(vehicle),'testdrive')}`} className={'btn btn-secondary mt-3'}>Book now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6"> {/* Changed from col-lg-4 to col-lg-6 */}
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={offers} className={'finished-svg'} /></div>

                                <div className="card-title text-center">
                                    <h5>Explore offers</h5>
                                    <p>View the latest {brand.name} deals.</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig , transformVehicle(vehicle),'offers')}`} className={'btn btn-secondary mt-3'}>View offers</a>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 
                    <div className="col-lg-4">
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={brochure} className={'finished-svg'} /></div>

                                <div className="card-title text-center">
                                    <h5>Download a Brochure</h5>
                                    <p>Find out more about your chosen {brand.name} model.</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig , transformVehicle(vehicle),'brochure')}`} className={'btn btn-secondary mt-3'}>Download</a>

                                </div>
                            </div>
                        </div>
                    </div>
                    */}
                </div>
                <LeapReviews vehicle={vehicle} />
            </div>
        )
    }

    let C = connect((state) => {
        const selector = formValueSelector(props.formName);

        return {

            brandConfig: selector(state, 'brandConfig'),
            vehicle: transformVehicle(selector(state, 'vehicle')),
            brand: selector(state, 'brand'),


        }
    })(Component);

    return <C {...props} />
}

export function RAQFinish(props){
    let Component = connect(state => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "We will contact you shortly with a quote. ",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(CompletedForm);

    return <Component {...props}><RAQOptions {...props}/></Component>
}

function RABOptions(props) {
    function Component(p){
        const brandConfig = p.brandConfig || {};
        const vehicle = p.vehicle || 'C10 Reev';
        const brand = p.brand || { name: 'leap' };

        return (
            <div>
                <div className={'row waiting p-3 pb-5 ml-3 mr-3 mt-5 card-deck'}>
                    <div className="col-sm-12 col-12">
                        <div className={"text-center m-4"}>
                            <h4>While you're waiting</h4>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={features} className={'finished-svg'}/> </div>

                                <div className="card-title text-center">
                                    <h5>Request a Quote</h5>
                                    <p>See great pricing at your local dealership.</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig, transformVehicle(vehicle), 'quote')}`} className={'btn btn-secondary mt-3'}>Request now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={offers} className={'finished-svg'} /></div>

                                <div className="card-title text-center">
                                    <h5>Explore offers</h5>
                                    <p>View the latest {brand.name} deals.</p> {/* This line was causing the error */}
                                    <a target="_parent" href={`${LookupCTA(brandConfig, transformVehicle(vehicle), 'features')}`} className={'btn btn-secondary mt-3'}>View offers</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="card mb-4 border-0">
                            <div className="card-body">
                                <div className="card-img-top text-center mb-4"><SVG src={testdrive} className={'finished-svg'} /></div>

                                <div className="card-title text-center">
                                    <h5>Book a Test Drive</h5>
                                    <p>Get behind the wheel at your local dealership.</p>
                                    <a target="_parent" href={`${LookupCTA(brandConfig, transformVehicle(vehicle), 'testdrive')}`} className={'btn btn-secondary mt-3'}>Book now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LeapReviews vehicle={vehicle} />
            </div>
        )
    }

    let C = connect((state) => {
        const selector = formValueSelector(props.formName);
        return {
            brandConfig: selector(state, 'brandConfig'),
            vehicle: transformVehicle(selector(state, 'vehicle')),
            brand: selector(state, 'brand'),
        }
    })(Component);

    return <C {...props} />
}

export function BrandBrochure(props){

    function Brochure(p){
        return <a href={p.brandConfig[transformVehicle(p.vehicle)].cta.specs} className={'btn btn-primary'} target="_parent">Download brochure</a>
    }

    let Component = connect((state) => {
        const selector = formValueSelector(props.formName);
        return {
            brandConfig: selector(state, 'brandConfig'),
            vehicle: transformVehicle(selector(state, 'vehicle')),
    } })(Brochure);

    return <Component {...props}/>
}

export function RABFinish(props){
    let Component = connect(state => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: props.brochureSentByEmail ? "Your brochure has been emailed to you. Please check your inbox." : "Your brochure is ready. Please click the button below to begin your download.",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig'),
            vehicle: transformVehicle(selector(state, 'vehicle')),

        }})(CompletedForm);

    return <Component {...props}>
        {!props.brochureSentByEmail &&
            <div className={'d-flex justify-content-center'}>
                <BrandBrochure formName={props.formName}/>
            </div>
        }
        <RABOptions {...props}/>
    </Component>
}


class ContactUsCompletedForm extends Component {
    render(){
        if(this.props.completed && this.props.result){
            return (<div id={'thank-you'}  className={"form-completed "}>
                <div className={"d-flex justify-content-center"}><SVG className={""} src={tickSvg}/></div>
                <div className={"card text-center border-0"}>
                    <div className="card-body">
                        <div className="card-title justify-content-center">
                            <h2 className={""}>Thank you,&nbsp;<span className={"greeting"}>{this.props.result && this.props.result["request"]["FirstName"]}</span></h2>
                        </div>
                        <div className="card-text justify-content-center">
                            <p className={" "}>A {this.props.values.brand.value.charAt(0).toUpperCase() + this.props.values.brand.value.slice(1)} {this.props.thankyoumessage}</p>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>)
        }
        else{
            return <span/>
        }
    }

}


export function ContactUsFinish(props){
    let Component = connect((state) => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "representative will contact you within 1-2 business days.",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(ContactUsCompletedForm);

    return <div className="col-12"><Component {...props}/></div>
}

export function ContactRecallFinish(props){
    let Component = connect((state) => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "representative will contact you.",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(ContactUsCompletedForm);

    return <div className="col-12"><Component {...props}/></div>
}

export function RYIFinish(props){
    let Component = connect((state) => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "We will contact you shortly.",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(RYICompletedForm);

    return <div className="col-12"><Component {...props}/></div>
}

export function RYIRFCFinish(props){
    let Component = connect((state) => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "We will contact you shortly.",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(RYIRFCCompletedForm);

    return <div className="col-12"><Component {...props}/></div>
}

const LookupCTA = (brandConfig , name, cta) => {
    return brandConfig && brandConfig[name] && brandConfig[name]['cta'] ?  brandConfig[name]['cta'][cta]: `#`
};

export function CompetitionForm(props){
    let Component = NamedForm(props.formName || "fca-competition", props);

    return <Component {...props}/>
}

class CompetitionCompletedForm extends Component {
    render(){
        if(this.props.completed && this.props.result){
            return (<div id={'thank-you'}  className={"form-completed "}>
                <div className={"d-flex justify-content-center"}><SVG className={""} src={tickSvg}/></div>
                <div className={"card text-center border-0"}>
                    <div className="card-body">
                        <div className="card-title justify-content-center">
                            <h2 className={""}>Thank you,&nbsp;<span className={"greeting"}>{this.props.result && this.props.result["request"]["FirstName"]}</span></h2>
                        </div>
                        <div className="card-text justify-content-center">
                            <p className={" "}>{this.props.thankyoumessage}</p>
                        </div>
                    </div>
                </div>
                {this.props.children}
            </div>)
        }
        else{
            return <span/>
        }
    }

}


export function CompetitionFinish(props){
    let Component = connect((state) => {

        const selector = formValueSelector(props.formName);

        return {

            completed : selector(state, 'completed'),
            values : getFormValues(props.formName)(state),
            thankyoumessage: "Thank you for entering. Good luck!",
            result : selector(state, props.data),
            brandConfig: selector(state, 'brandConfig')

        }})(CompetitionCompletedForm);

    return <div className="col-12"><Component {...props}/></div>
}

// --- REVIEWS COMPONENT ---
function LeapReviews({ vehicle }) {
    const quoteStart = '\u201C';
    const quoteEnd = '\u201D';

    const reviewsData = {
        "C10": {
            title: "C10 REVIEWS",
            intro: "The automotive media is all talking about the all-new, all-electric C10 SUV, and we're excited to share the buzz with you! From our fantastic value, spacious interior and wealth of features, the Leapmotor C10 is turning heads.",
            reviews: [
                {
                    text: "It's a lot of electric SUV for your money, not to mention the plethora of standard equipment on offer, and an incredibly spacious cabin families will appreciate.",
                    source: "- Carsales",
                    link: "https://www.carsales.com.au/editorial/details/leapmotor-c10-2025-review-148550/"
                },
                {
                    text: "A cool feature in this car is that you can fold the front seats back to create an almost-flat space for lounging.",
                    source: "– CarExpert",
                    link: "https://www.carexpert.com.au/car-reviews/2025-leapmotor-c10-review"
                },
                {
                    text: "The C10's cabin is cavernous, particularly in the second row, where there's leg and toe room galore!",
                    source: "- Carsales",
                    link: "https://www.carsales.com.au/editorial/details/leapmotor-c10-2025-review-148550"
                },
                {
                    text: "The big news with the introduction of the Leapmotor C10 is its headline-grabbing drive-away price-tag.",
                    source: "- Carsales",
                    link: "https://www.carsguide.com.au/ev/leapmotor-c10-96527"
                }
            ]
        },
        "C10 Reev": {
            title: "C10 REEV REVIEWS",
            intro: "The automotive media is all talking about the all-new C10 SUV, and we're excited to share the buzz with you! From our fantastic value, spacious interior and wealth of features, the Leapmotor C10 is turning heads.",
            reviews: [
                {
                    text: "The engine is genuinely refined, and the C10 REEV drive experience is impressively quiet, insulated and vibration free.",
                    source: "– Drive",
                    link: "https://www.drive.com.au/reviews/2025-leapmotor-c10-reev-review-international-first-drive/"
                },
                {
                    text: "Leapmotor C10 REEV is Australia's most affordable PHEV.",
                    source: "– Carsales",
                    link: "https://www.carsales.com.au/editorial/details/leapmotor-c10-reev-2025-review-149168/"
                },
                {
                    text: "Every turn was smooth, every acceleration was gentle, likely thanks to chassis tuning by Maserati engineers.",
                    source: "– News.com.au",
                    link: "https://www.news.com.au/special-features/leapmotor-c10-reev-review-barcelona-test-drive/news-story/52ccb9a0cfced6227325b6184b641a96"
                },
                {
                    text: "On the road, the C10 REEV offers a driving experience remarkably close to a full EV. In pure electric mode, it's silent, smooth, and effortless.",
                    source: "– Autocar",
                    link: "https://www.autocar.co.nz/leapmotor-c10-reev-first-drive-ev-first-with-petrol-peace-of-mind/"
                },
                {
                    text: "Probably the most remarkable thing about C10 REEV is just how similar it feels to the electric version to drive.",
                    source: "– Carsguide",
                    link: "https://www.carsguide.com.au/ev/leapmotor-c10-reev-97560"
                }
            ]
        },
        "B10": {
            title: "B10 REVIEWS",
            intro: "Discover the buzz that’s building as Aussie media meet the latest addition to our line-up. Starting from an unbeatable driveaway, packed with features in one sleek package - the all-new Leapmotor B10 is turning heads.",
            reviews: [
                {
                    text: "Such sharp entry pricing will make the B10 Australia’s most affordable electric SUV.",
                    source: "– CarExpert",
                    link: "https://www.carexpert.com.au/car-reviews/2026-leapmotor-b10-review"
                },
                {
                    text: "The boot is decent, with 430 litres on offer with the seats in place. That grows to more like 1700 litres with the seats folded flat.",
                    source: "– CarsGuide",
                    link: "https://www.carsguide.com.au/ev/leapmotor-b10-99949"
                },
                {
                    text: "We’re talking crazy value here.",
                    source: "– EV Central",
                    link: "https://evcentral.com.au/2026-leapmotor-b10-review-the-cut-price-chinese-ev-that-doesnt-drive-like-a-chinese-ev/"
                }
            ]
        }
    };

    const vehicleData = reviewsData[vehicle];

    if (!vehicleData) {
        return null;
    }

    return (
        <div className="container my-5">
            <h4 className="text-center mb-4">{vehicleData.title}</h4>
            <div className="mx-auto" style={{ maxWidth: '800px' }}>
                {vehicleData.intro && (
                    <p className="text-center mb-4">
                        {vehicleData.intro}
                    </p>
                )}
                <div className="mt-4">
                    {vehicleData.reviews.map((review, index) => (
                        <div key={index} 
                             className="card mb-3 border border-green"
                             onClick={() => review.link && window.open(review.link, '_blank')}
                             style={{ cursor: review.link ? 'pointer' : 'default' }}
                        >
                            <div className="card-body">
                                <p className="card-text text-start fst-italic" style={{fontStyle: 'italic'}}>
                                    {quoteStart}{review.text}{quoteEnd}
                                </p>
                                <h5 style={{ textAlign: 'right', color: '#333333' }}>{review.source}</h5>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}